// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3Vn5M","header":"Messages_header__29FEb"};